import { CustomTextArea, SampleDatePicker } from "@/shared/components/ui";
import CustomAutoCompleteGroupBy from "@/shared/components/ui/CustomAutoCompleteGroupBy";
import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import { useState } from "react";
import useTicketPendientesAsignacion from "../../hooks/useTicketPendientesAsignacion";
import TimeClockComponente from "@/shared/components/ui/TimeClock/TimeClockComponente";
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AssignmentIcon from '@mui/icons-material/Assignment';

export default function ViewAsignacionTecnicos() {
  const {
    control,
    form,
    errors
  } = useTicketPendientesAsignacion()
  const [tecnicos, setTecnicos] = useState<any>(null)
  return (
    <Grid container spacing={3}>
      {/* Sección: Selección de Técnico y Fecha */}
      <Grid item xs={12}>
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <PersonIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6" color="primary.main" fontWeight={600}>
              Información del Técnico
            </Typography>
          </Box>
          <Divider sx={{ mb: 3 }} />
          
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <PersonIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
                <Typography variant="subtitle2" color="text.secondary" fontWeight={500}>
                  Técnicos Disponibles
                </Typography>
              </Box>
              <CustomAutoCompleteGroupBy
                label="Seleccionar técnico"
                options={[]}
                value={tecnicos}
                onChange={(value) => setTecnicos(value)}
                getOptionLabel={(option) => option.tecnico}
                isOptionEqualToValue={(option, value) => option.tecnico === value.tecnico}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <CalendarMonthIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
                <Typography variant="subtitle2" color="text.secondary" fontWeight={500}>
                  Fecha de Asignación
                </Typography>
              </Box>
              <SampleDatePicker
                label="Seleccione la fecha"
                name="fecha"
                defaultValue={form.getValues("fecha") || ''}
                control={control}
                error={form.formState.errors.fecha as any}
                helperText={form.formState.errors.fecha?.message as any}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      {/* Sección: Horario */}
      <Grid item xs={12}>
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <AccessTimeIcon sx={{ mr: 1, color: 'success.main' }} />
            <Typography variant="h6" color="success.main" fontWeight={600}>
              Horario Disponible
            </Typography>
          </Box>
          <Divider sx={{ mb: 3 }} />
          
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <AccessTimeIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
                <Typography variant="subtitle2" color="text.secondary" fontWeight={500}>
                  Hora Disponible del Técnico
                </Typography>
              </Box>
              <TimeClockComponente
                label="Seleccione la hora"
                name="hora_disponible_tecnico"
                defaultValue={form.getValues("hora_disponible_tecnico") || ''}
                control={control}
                error={errors.hora_disponible_tecnico as any}
                helperText={errors.hora_disponible_tecnico?.message as any}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      {/* Sección: Actividades */}
      <Grid item xs={12}>
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <AssignmentIcon sx={{ mr: 1, color: 'warning.main' }} />
            <Typography variant="h6" color="warning.main" fontWeight={600}>
              Actividades Asignadas
            </Typography>
          </Box>
          <Divider sx={{ mb: 3 }} />
          
          <CustomTextArea
            label="Describa detalladamente las actividades a realizar"
            name="actividades_asignadas"
            control={control}
            error={errors.actividades_asignadas as any}
            helperText={errors.actividades_asignadas?.message as any}
            rows={4}
          />
        </Paper>
      </Grid>
    </Grid>
  )
}